import React from 'react'
import { ModalProvider } from './src/utils/ModalContext'

export const wrapRootElement = ({ element }) => (
  <ModalProvider>{element}</ModalProvider>
)
